import React from "react";
import { SpinnerElem } from "./Spinner.styled";

export default function Spinner() {
  return <SpinnerElem></SpinnerElem>;
}
